export const RegisterBusiness = 'register-business';

export const RegisterBusinessView = `/${RegisterBusiness}`;
